<template>

  <div @click="setFocus" id="AddressSelectComponent" class="position-relative">

    <!-- <div v-if="!flag" class="addressSelectIcon"> -->
    <!-- <img src="/assets/images/Vector.svg"> -->
    <!-- </div> -->
    <!-- <div v-if="flag" class="addressSelectIcon"> -->
    <!-- <img src="/assets/images/Frame.svg"> -->
    <!-- </div> -->

    <div class="addressSearch">
      <p v-if="rent" :class="{ 'error-message-color': !isValid }">{{ placeHolder }}</p>
      <vue-google-autocomplete classname="form-control" country="lt" ref="address" types="" :id="id"
        :placeholder="rent ? '' : placeHolder" @inputChange="getChange" @placechanged="getAddressData">
      </vue-google-autocomplete>
    </div>
    <template v-if="!isValid">
      <MessageComponent :message-class="'error-address-message'" :message="message"></MessageComponent>
    </template>
  </div>

</template>

<script>
import VueGoogleAutocomplete from "../../../js/plugins/vue-google-autocomplete/src/VueGoogleAutocomplete.vue";
import './AddressSelect.scss';
import MessageComponent from "../message/MessageComponent.vue";

export default {
  components: { VueGoogleAutocomplete, MessageComponent },
  props: {
    flag: {
      type: Boolean,
      required: false
    },
    rent: {
      type: Boolean,
      required: true
    },
    placeHolder: {
      type: String,
      required: true
    },
    pickupAddress: {
      type: Boolean,
      required: false
    },
    locationStore: {
      type: Object
    },
    id: {
      type: String
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    message: {
      type: String
    }

  },
  emits: ['getAddress'],
  data: function () {
    return {};
  },

  mounted() {
    if (this.locationStore && !this.locationStore.country) {
      // Add or override country to 'LT'
      this.locationStore.country = 'LT';
    }
    // console.log(this.locationStore);

    this.displayAddress(this.locationStore);
  },


  watch: {
    locationStore(newAddress, oldAddress) {
      this.displayAddress(newAddress);
    }
  },

  methods: {
    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData: function (addressData, placeResultData, id) {
      let country = null;

      // Check if placeResultData and address_components exist
      if (placeResultData && placeResultData.address_components) {
        // Find the address component with type 'country'
        const countryComp = placeResultData.address_components.find(comp =>
          comp.types && comp.types.includes('country')
        );
        if (countryComp) {
          country = countryComp.short_name;  // Use 'short_name' for country code (e.g., 'LT')
        }
      }

      // Pass the country (and other fields) forward
      this.triggerAddressChange({
        ...addressData,
        country:"LT",  // Add the country code
        formatted_address: placeResultData.formatted_address,
        place_id: placeResultData.place_id,
        url: placeResultData.url
      });
    },

    displayAddress: function (payload) {
      if (!payload) {
        return this.$refs.address.autocompleteText = "";
      }
      let str = '';

      if (payload.raw) {
        const raw = payload.raw;

        str += raw.formatted_address;

        if (raw.formatted_address.indexOf(raw.name) < 0) {
          str = raw.name + ', ' + str;
        }
      }

      return this.$refs.address.autocompleteText = str;
    },

    getChange: function () {
      if (this.$refs.address.autocompleteText.length !== 0) {
        return;
      }
      this.triggerAddressChange();
    },

    setFocus: function () {
      this.$refs.address.focus();
      this.$refs.address.$refs.autocomplete.select();
    },

    triggerAddressChange: function (value = null) {
      this.$emit('getAddress', { value, pickup: !!this.pickupAddress });
    }
  },
};
</script>
